import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import Navigation from './Navigation';
import Toast from './Toast';
import { useApp } from '../context/AppContext';

export default function Layout() {
  const { addNotification } = useApp();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    
    // Simple error reporting
    if (hash.includes('error=')) {
      const params = new URLSearchParams(hash.substring(1));
      const errorMsg = params.get('error_description') || params.get('error');
      if (errorMsg) {
        addNotification(`Security: ${errorMsg.replace(/\+/g, ' ')}`, 'error');
        navigate(location.pathname, { replace: true });
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col font-sans">
      <Toast />
      <Header />
      <main className="flex-1 w-full max-w-screen-md mx-auto relative overflow-y-auto overflow-x-hidden">
        <Outlet />
      </main>
      <Navigation />
    </div>
  );
}